import { action } from "../const";

const initialState = {
    isSocketLogin: false,
    isConnecting: "die",     // "connecting", "connected", "die"

    groupConversation: [],
    newConversation: undefined,
    groups: [],
    chatHistory: [],
    selectedGroup: {},
    messageQueue: [],

    groupId: undefined,
    messages: [],
};

export default function chatReducer(state = initialState, data) {

    switch (data.type) {
        case action.UPDATE_CHAT_STATE:
            return Object.assign({}, state, data.payload)

        case action.NEW_CONVERSATION_LIST:
            return { ...state, newConversation: data.data }

        case action.CONVERSATION_LIST:
            return { ...state, groupConversation: data.groups }

        case action.IS_SOCKET_LOGIN: return { ...state, isSocketLogin: true }
        case action.IS_SOCKET_LOGOUT: return { ...state, isSocketLogin: false }

        case action.IS_SOCKET_CONNECTING: return { ...state, isConnecting: "connecting" }
        case action.IS_SOCKET_CONNECTED: return { ...state, isConnecting: "connected" }
        case action.IS_SOCKET_DIE: return { ...state, isConnecting: "die" }
        case action.GROUP_MESSAGES_TARGET: return { ...state, groupId: data.id }
        case action.GROUP_MESSAGES:
            let messages = state.messages;
            messages = [...messages, data.messages]
            return { ...state, messages: data.messages }

        case action.USER_LOGOUT:
            return { ...initialState, isSocketLogin: false }

        default:
            break;
    }

    return state;
}